import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { motion } from 'framer-motion'
import { s3Static } from '../../../../utils/constants'
import { localiseTerms } from '../../../../utils/markets'

const brands = [
    { name: 'Samsung',    img: 'Samsung.png',                          alt: 'Samsung Aircon Servicing - StringsSG',    href: '/sg/aircon-servicing-singapore/samsung', h: 'h-10 md:h-14' },
    { name: 'Prism+',     img: 'aircon/prism%2B-aircon-brand.png',     alt: 'Prism+ Aircon Servicing - StringsSG',     href: '/sg/aircon-servicing-singapore/why-prism-is-the-ultimate-brand-for-you', h: 'h-8 md:h-10' },
    { name: 'Midea',      img: 'midea-aircon.png',                     alt: 'Midea Aircon Servicing - StringsSG',      href: null, h: 'h-8 md:h-10' },
    { name: 'Fujitsu',    img: 'Fujitsu.png',                          alt: 'Fujitsu Aircon Servicing - StringsSG',    href: null, h: 'h-8 md:h-10' },
    { name: 'Panasonic',  img: 'Panasonic.png',                        alt: 'Panasonic Aircon Servicing - StringsSG',  href: '/sg/aircon-servicing-singapore/panasonic', h: 'h-10 md:h-14' },
    { name: 'LG',         img: 'LG.png',                               alt: 'LG Aircon Servicing - StringsSG',         href: '/sg/aircon-servicing-singapore/lg-air-conditioner', h: 'h-8 md:h-10' },
    { name: 'Mitsubishi', img: 'Mitsubishi.png',                       alt: 'Mitsubishi Aircon Servicing - StringsSG', href: '/sg/aircon-servicing-singapore/mitsubishi-electric', h: 'h-8 md:h-10' },
    { name: 'Daikin',     img: 'Daikin.png',                           alt: 'Daikin Aircon Servicing - StringsSG',     href: '/sg/aircon-servicing-singapore/daikin', h: 'h-8 md:h-10' },
]

const BrandCard = ({ brand, index }) => {
    const inner = (
        <div
            className={`group relative flex items-center justify-center rounded-2xl p-4 md:p-5
                bg-white/50 backdrop-blur-xl border border-white/70
                shadow-[0_4px_24px_rgba(251,146,60,0.06)]
                hover:shadow-[0_8px_32px_rgba(251,146,60,0.14)]
                hover:-translate-y-0.5 hover:border-orange-200/60
                transition-all duration-400`}
        >
            <div className={`relative w-full ${brand.h}`}>
                <Image
                    src={s3Static + brand.img}
                    fill
                    style={{ objectFit: 'contain', objectPosition: 'center' }}
                    placeholder="blur"
                    blurDataURL={s3Static + 'placeholder.png'}
                    alt={brand.alt}
                    sizes="(max-width: 768px) 25vw, 15vw"
                    className="opacity-90 group-hover:opacity-100 transition-opacity duration-300"
                />
            </div>
            {/* Brand name tooltip on hover */}
            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-0 opacity-0 group-hover:opacity-100 group-hover:-translate-y-1 text-[10px] font-semibold text-orange-600 bg-white/80 backdrop-blur-sm px-2 py-0.5 rounded-full border border-orange-100 shadow-sm transition-all duration-300 pointer-events-none whitespace-nowrap">
                {brand.name}
            </span>
        </div>
    )

    if (brand.href) {
        return (
            <Link href={brand.href} prefetch={false} className="block">
                {inner}
            </Link>
        )
    }

    return inner
}

// UAE / Malaysia: `market` (local term in the alt text), `intro` copy,
// `linked={false}` (no brand pages there) and `exclude` brand names (Prism+ is
// sold only in Singapore).
export const AirconBrandsWeSupport = ({ market, intro, linked = true, exclude = [] } = {}) => {
    const shown = brands
        .filter((brand) => !exclude.includes(brand.name))
        .map((brand) => (linked ? brand : { ...brand, href: null, alt: localiseTerms(brand.alt, market) }))
    return (
        <section className="relative py-8 md:py-14 overflow-hidden">
            {/* Ambient blobs */}
            <div className="relative max-w-5xl mx-auto px-4">
                {/* Header */}
                <div className="text-center mb-10 md:mb-6">
                    <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight">
                        Brands We Support
                    </h2>
                    <p className="mt-2 text-gray-500 text-sm max-w-lg mx-auto">
                        {intro ?? 'Our technicians are certified to service and repair all major aircon brands in Singapore.'}
                    </p>
                </div>

                {/* Brands Grid */}
                <div className="grid grid-cols-4 gap-3 md:gap-5">
                    {shown.map((brand, i) => (
                        <BrandCard key={brand.name} brand={brand} index={i} />
                    ))}
                </div>
            </div>
        </section>
    )
}
